import React from 'react';
import { ApplicationView } from '@aha-app/mvc';

export const ContentError = ({ message }: { message: string }) => {
  return (
    <span
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'var(--spacer-2)',
      }}
    >
      <i
        className='far fa-file-circle-question'
        style={{ paddingRight: 'var(--spacer-2)' }}
      />{' '}
      {message}
    </span>
  );
};

export default ApplicationView(ContentError);
